<template>

    <validation-observer ref="validationObserver" v-slot="{ invalid, errors }">


        <!-- DATE OR START DATE -->
        <v-menu v-if="!disableEdit"
            v-model="menuModel"
            ref="dateMenu"
            :close-on-content-click="false"
            :return-value.sync="pickerDateModel"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            max-width="450px"
            min-width="290px"
        >
            <template v-slot:activator="{ on }">

                <v-text-field
                    v-on="on"
                    solo
                    :value="dateDisplay"
                    label="Date"
                    :persistent-hint="!compact"
                    hint="Date"
                    :hide-details="true"
                    readonly
                    placeholder="Select date"
                    :background-color="color"
                    :error-messages="errorMessages"
                ></v-text-field>

            </template>

            <validation-provider
                name="Date"
                rules="required"
                v-slot="{ errors }">

                <v-date-picker
                    v-model="pickerDateModel"
                    color="primary"
                    header-color="primary"
                    :landscape="true"
                    @input="datePicked"
                    @click:date="$refs.dateMenu.save(pickerDateModel)"
                >
                </v-date-picker>

            </validation-provider>

        </v-menu>

        <!-- NON EDITABLE VIEW -->
        <div v-if="disableEdit">

            <v-chip class="mr-2"
                    text-color="white"
                    dark small
                    label
                    color="grey darken-1">
                {{ dateDisplay }}
            </v-chip>
        </div>
    </validation-observer>
</template>

<script>

import moment from 'moment';
import {timeDisplay} from "../../../../components/mixins/timeDisplayMixin";

export default {

    mixins: [timeDisplay],

    props: {
        value: {
            required: true,
            type: String | null,
            default: null
        },
        disableEdit: {
            required: false,
            type: Boolean,
            default: false,
        },
        color: {
            type: String,
            required: true,
        },
        compact: {
            type: Boolean,
            required: false,
            default: false,
        }
    },

    watch: {
        value(value) {
            this.pickerDateModel = value;
        },
    },

    computed: {

        dateDisplay() {
            if (this.pickerDateModel) {
                return this.formatDate(this.pickerDateModel);
            }
        },
    },

    data() {
        return {
            menuModel: null,
            pickerDateModel: null,
            errorMessages: []
        }
    },

    created() {
        this.pickerDateModel = this.value;
    },

    methods: {

        datePicked() {
            this.dateModel = moment(this.pickerDateModel, 'YYYY-MM-DD').format('L');
            this.validate();
        },

        validate() {
            if (this.dateModel) {

                this.$nextTick(() => {
                    this.$refs.validationObserver.validate()
                        .then(isValid => {
                            if (isValid) {
                                this.errorMessages = [];
                                this.$emit('input', this.pickerDateModel);
                            } else {
                                this.errorMessages = ['Date is required'];
                            }
                        });
                });
            }
        },
    }
}
</script>
